import { AxiosError } from "axios";

import contractManagementGepoApi from "../contractManagementGepoApi";
import { apiPost } from "../../common/utils/request.utils";
import { GetUsersArg, UserType } from "./types";

const service = contractManagementGepoApi.injectEndpoints({
	endpoints: (builder) => ({
		getUsers: builder.query<UserType[], GetUsersArg | void>({
			queryFn: async (arg) => {
				try {
					const response = await apiPost(
						"external-services/users",
						arg?.group_filter
							? { group_filter: arg.group_filter }
							: {}
					);
					return { data: response.data as UserType[] };
				} catch (error) {
					const err = error as AxiosError;
					return {
						error: {
							status: err.response?.status,
							data: err.response?.data || err.message,
						},
					};
				}
			},
		}),
	}),
});

export const { useGetUsersQuery } = service;

export default service;
